module.exports = __webpack_public_path__ + "static/media/house.73d56b9c.svg";